import React from 'react';
import { UserActivityDashboard } from '@/components/analytics/UserActivityDashboard';

const UserActivityPage: React.FC = () => {
  return <UserActivityDashboard />;
};

export default UserActivityPage;